export default {"src":"/_next/static/media/icon-color.1e49f1c7.svg","height":461,"width":478};